// @flow

import { rem } from 'polished';
import styled from 'styled-components';

export const IconAndDetailsFlexRow = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0 1rem 0 ${rem(10)};
  transform: ${props => (props.submittedDate ? 'translateY(-10px)' : 'none')};
`;

export const DetailsContainer = styled.div`
  padding-top: ${rem(7)};
`;
